exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-txt-error {\n  text-align: center;\n}\n.modal-ttl-error {\n  color: #ff0000\n}\n", ""]);

// exports
